module.exports = __webpack_public_path__ + "img/dots-vertical.17eeb9c3.svg";